<template>
  <b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
    <div>
      <CRow>
        <CCol>
          <CInput
              label="Ime"
              v-model="modalNonWorkingDay.name"/>
        </CCol>
        <CCol>
          <v-date-picker
              locale="sl-SI"
              v-model="modalNonWorkingDay.date"
              :model-config=" {
									type: 'string',
								}"
              timezone='utc'>
            <template v-slot="{ inputValue, inputEvents }">
              <CInput
                  label="Datum"
                  :value="inputValue"
                  v-on="inputEvents"/>
            </template>
          </v-date-picker>
        </CCol>
      </CRow>
    </div>
    <CAlert v-show="message.text != null" :color="message.type">
      {{ message.text }}
    </CAlert>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <b-container fluid class="p-0">
        <b-row>
          <b-col align-self="end" class="ma_pos">
            <b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
            <b-button :disabled="okButton.disabled || !isFormValid" :title="isFormValid ? '' : 'Preverite vnos podatkov'" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <vue-loading :active.sync="isLoading" :is-full-page="false"/>
  </b-modal>
</template>

<script>
import { NON_WORKING_DAY_CREATE_EDIT } from "@/store/actions/nonWorkingDays";

export default {
  name: 'non-working-day-create-edit-modal',
  components: {
  },
  props: {
  },
  methods: {
    showModal: function (modalInput) {
      /*
        mode 1 => Create
        mode 2 => Edit
      */
      this.mode = modalInput.mode;
      this.initModal(modalInput.modalNonWorkingDay);
    },
    initModal: function (modalNonWorkingDay) {
      if (this.mode === this.mode_CREATE1) {
        this.title = 'Dodajanje dneva';
        this.okButton.label = 'Dodaj';
      } else if (this.mode === this.mode_EDIT2) {
        this.title = 'Urejanje dneva ' + modalNonWorkingDay.name + ' (#' + modalNonWorkingDay.id + ')';
        this.initNonWorkingDay(modalNonWorkingDay);
        this.okButton.label = 'Shrani';
      } else {
        this.mode = this.mode_UNKNOWN0;
        this.title = 'Neznan način';
        this.okButton.label = 'Zapri';
      }
      this.$refs.modal.show();
    },
    initNonWorkingDay: function (modalNonWorkingDay) {
      this.modalNonWorkingDay.id = modalNonWorkingDay.id;
      this.modalNonWorkingDay.name = modalNonWorkingDay.name;
      this.modalNonWorkingDay.date = modalNonWorkingDay.date;
    },
    onOkModal: function () {
      this.startProgress();
      const modalNonWorkingDay = this.modalNonWorkingDay;
      this.$store.dispatch(NON_WORKING_DAY_CREATE_EDIT, { modalNonWorkingDay })
          .then((responseData) => {
            this.stopProgress();
            this.$emit('emit_nonWorkingDayCreatedOrEdited', responseData);
            this.$refs.modal.hide();
          })
          .catch(error => {
            this.stopProgress();
            console.error(error);
            if(error.response && error.response.data && error.response.data.code) {
              if (this.mode === this.mode_CREATE1) {
                this.showAlert('Napaka pri dodajanju! (' + error.response.data.code + ' - ' +  error.response.data.message + ')', this.ALERT_TYPE_ERROR);
              } else if (this.mode === this.mode_EDIT2) {
                this.showAlert('Napaka pri urejanju! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
              } else {
                this.showAlert('Neznan način modala! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
              }
            } else {
              this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
            }
          });
    },
    clearModalData: function () {
      this.isLoading = false;
      this.title = '';
      this.okButton = {
        label: 'Shrani',
        progress: false,
        disabled: false
      };
      this.showAlert();
      this.mode = 0;
      this.modalNonWorkingDay.id = 0;
      this.modalNonWorkingDay.name = '';
      this.modalNonWorkingDay.date = '';
    },
    startProgress: function () {
      this.isLoading = true;
      this.okButton.disabled = true;
      this.okButton.progress = true;
    },
    stopProgress: function () {
      this.isLoading = false;
      this.okButton.disabled = false;
      this.okButton.progress = false;
    },
    showAlert: function (message, type, seconds) {
      if (message && type && seconds) {
        this.message.type = type;
        this.message.text = message;
        setTimeout(() => {
          this.showAlert();
        }, seconds * 1000);
      } else if (message && type) {
        this.message.type = type;
        this.message.text = message;
      } else if (message) {
        this.message.type = 'primary';
        this.message.text = message;
      } else {
        this.message.type = null;
        this.message.text = null;
      }
    }
  },
  data: function () {
    return {
      isLoading: false,
      title: '',
      okButton: {
        label: 'Shrani',
        progress: false,
        disabled: false
      },
      message: {
        type: null,
        text: null
      },
      ALERT_TYPE_SUCCESS: 'success',
      ALERT_TYPE_ERROR: 'danger',
      mode_UNKNOWN0: 0,
      mode_CREATE1: 1,
      mode_EDIT2: 2,
      mode: 0,
      modalNonWorkingDay: {
        id: 0,
        name: '',
        date: '',
      }
    }
  },
  watch: {
  },
  computed: {
    modalSize () {
      return 'md';
    },
    isFormValid() {
      return this.isValidName && this.isValidDate;
    },
    isValidName() {
      return !!this.modalNonWorkingDay.name;
    },
    isValidDate() {
      return !!this.modalNonWorkingDay.date;
    }
  }
}
</script>

<style scoped>
.ma_pos {
  text-align: end;
}
</style>